import LogRocket from 'logrocket';

import { hasStringValue } from '@core/utils/equality';

const STORAGE_VERSION = 'v1';

export const saveInStorage = <T>(persistingName: string, data: T): void => {
  try {
    localStorage.setItem(`${persistingName}_${STORAGE_VERSION}`, JSON.stringify(data));
  } catch (error) {
    LogRocket.error('Error saving item:', error);
  }
};

export const getFromStorage = <T>(persistingName: string, defaultValue: T): T => {
  try {
    const itemString = localStorage.getItem(`${persistingName}_${STORAGE_VERSION}`);
    if (hasStringValue(itemString)) {
      return JSON.parse(itemString as string) as T;
    }
  } catch (error) {
    LogRocket.error('Error saving item:', error);
  }

  return defaultValue;
};

export const removeFromStorage = (persistingName: string): void => {
  try {
    localStorage.removeItem(`${persistingName}_${STORAGE_VERSION}`);
  } catch (error) {
    LogRocket.error('Error saving item:', error);
  }
};
